import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, ComponentRef } from '@angular/core';
import { SharedModule } from '@common/shared.module';
import { DeniedModalComponent } from './denied-modal.component';

@Injectable({
    providedIn: SharedModule,
})
export class DeniedModalService {
    private _componentRef: ComponentRef<DeniedModalComponent>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private appRef: ApplicationRef, private injector: Injector) {}

    showModal(DenialReasonId: number): void {
        this.destroyComponent();
        this._componentRef = this.componentFactoryResolver.resolveComponentFactory(DeniedModalComponent).create(this.injector);
        this._componentRef.instance.denialType = DenialReasonId;
        this._componentRef.instance.onCancel.subscribe(() => {
            this.destroyComponent();
        });

        this.appRef.attachView(this._componentRef.hostView);
        const domElem = (this._componentRef.hostView as EmbeddedViewRef<DeniedModalComponent>).rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);
    }

    private destroyComponent(): void {
        if (this._componentRef) {
            this.appRef.detachView(this._componentRef.hostView);
            this._componentRef.destroy();
            this._componentRef = null;
        }
    }
}
